<script setup lang="ts">
import { computed, ref } from 'vue';

import settings from '@/settings';
import { getScriptData } from '@/utils';

import ErrorDisplay from '@/components/ErrorDisplay.vue';

const { csrfToken } = settings;
const errors = getScriptData('session-errors');

const isBusy = ref(false);
const username = ref<string | null>(null);
const password = ref<string | null>(null);
const remember = ref(false);

const isFormChanged = computed(
    (): boolean => Boolean(username.value) && Boolean(password.value)
);
</script>


<template>
    <div class="row mt-5">
        <div class="offset-sm-3 col-sm-6 offset-lg-4 col-lg-4">
            <div class="card">
                <div class="card-header">
                    <h1 class="h3">
                        Login
                    </h1>
                </div>
                <div class="card-body">
                    <ErrorDisplay :value="errors" />

                    <form method="post" action="/auth/login">
                        <input type="hidden" name="_token" :value="csrfToken">
                        <div class="mb-3 required">
                            <label for="user_username" class="form-label">Username</label>
                            <input
                                id="user_username"
                                v-model="username"
                                class="form-control"
                                name="user_username"
                                required
                            >
                        </div>

                        <div class="mb-3 required">
                            <label for="password" class="form-label">Password</label>
                            <input
                                id="password"
                                v-model="password"
                                class="form-control"
                                type="password"
                                name="password"
                                required
                            >
                        </div>

                        <div>
                            <input
                                id="remember"
                                v-model="remember"
                                type="checkbox"
                                name="remember"
                                :true-value="true"
                                :false-value="false"
                            >
                            Keep me signed in
                        </div>

                        <button
                            class="btn btn-success btn-sm m-2"
                            type="submit"
                            :disabled="!isFormChanged || isBusy"
                        >
                            <span class="fas fa-share" /> Login
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
